<template>
  <div id="layout">
    <i-local-nexon-text height="22px" class="nexon-logo" />
    <h1 v-if="title" class="text-center">
      {{ $t(title) }}
    </h1>
    <div class="contents"><slot /></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AccountContainer',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  computed: {},
  methods: {},
})
</script>

<style lang="less" scoped>
#layout {
  max-width: 320px;
  margin: 0 auto;
  text-align: center;
  .nexon-logo {
    display: inline-flex;
    width: 140px;
    margin-top: 80px;
  }

  h1 {
    text-transform: uppercase; // capitalize;
    color: var(--text-c);
    margin: 15px 0 25px 0;
    font-size: 16px;
    font-weight: 400;
    &.spaced-newlines {
      white-space: pre-line;
    }
  }

  .contents {
    border-top: 1px solid var(--border-c);
  }
}
@media only screen and (min-width: 480px) {
  #layout {
    max-width: 460px;
  }
}

@media only screen and (min-width: 768px) {
  #layout {
    max-width: 640px;
    .logo {
      width: 151px;
    }
    h1 {
      font-size: 18px;
    }
  }
}
.custom-header {
  .logo-container {
    display: block;
    margin-bottom: 15px;
  }
  .custom-title {
    display: block;
    color: fade(#fff, 50%);
    font-weight: bold;
    position: relative;
    margin-bottom: -1px;
    margin-top: 30px;
    a {
      display: inline-block;
      padding: 13px 10px;
      &.active {
        color: fade(#fff, 100%);
        border-bottom: 2px solid #0077ff;
      }
    }
  }
  #login-link,
  #create-account-link {
    display: none !important;
  }
}
</style>

<style lang="less">
.light {
  #layout {
    .nexon-logo {
      filter: invert(0%) sepia(100%) saturate(100%) hue-rotate(283deg) brightness(0) contrast(103%);
    }
  }
}
</style>
